import {Http} from '../../../Data/config/Http';
import {PaymentDTO, PaymentFilterParams, PaymentStatistics} from '../models/Payment';
import {API_ROUTES, ApiUtils} from '../../../constants/apiRoutes';
import {LoggerService} from '../../../Services/common/LoggerService';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export const paymentsAPI = {
  async getAllPayments (): Promise<PaymentDTO[]> {
    LoggerService.api(API_ROUTES.BILLING.PAYMENTS, 'get');
    const url = API_ROUTES.BILLING.PAYMENTS;
    LoggerService.debug('Fetching all payments from', {url});

    try {
      const response = await Http.get<BaseResponse<PaymentDTO[]>>(url);
      LoggerService.debug('All payments response received', response.data);
      return unwrapResponse(response.data, 'حدث خطأ في جلب المدفوعات');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async getPaymentsWithFilters (params: PaymentFilterParams): Promise<{ items: PaymentDTO[]; pagination?: any }> {
    LoggerService.api(API_ROUTES.BILLING.PAYMENTS, 'get', params);
    const url = API_ROUTES.BILLING.PAYMENTS;
    LoggerService.debug('Fetching payments with filters from', {url});

    try {
      const queryParams = ApiUtils.buildUrl(url, params);
      LoggerService.debug('Full URL with params', {queryParams});

      const response = await Http.get<BaseResponse<PaymentDTO[]>>(queryParams);
      LoggerService.debug('Payments with filters response received', response.data);
      const raw = response.data;
      const items = unwrapResponse(raw, 'حدث خطأ في جلب المدفوعات');

      return {
        items,
        pagination: raw.pagination
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  },


  async getStatistics (): Promise<PaymentStatistics> {
    LoggerService.api(API_ROUTES.BILLING.STATISTICS, 'get');
    const url = API_ROUTES.BILLING.STATISTICS;
    LoggerService.debug('Fetching payment statistics from', {url});

    try {
      const response = await Http.get<BaseResponse<PaymentStatistics>>(url);
      LoggerService.debug('Payment statistics response received', response.data);
      return unwrapResponse(response.data, 'حدث خطأ في جلب إحصائيات المدفوعات');
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};
